import { useEffect, useState } from "react";
import { ImWhatsapp } from "react-icons/im";
import { useParams } from "../../hooks/Params";
import styles from "./styles.module.scss";

export default function FloatLinks() {
  const [isVisible, setIsVisible] = useState(false);
  const { params } = useParams();

  function watchScroll() {
    if (window.scrollY > 450) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }

  useEffect(() => {
    if (window.innerWidth < 1100) {
      window.addEventListener("scroll", watchScroll);
    } else {
      setIsVisible(true);
    }
    return () => window.removeEventListener("scroll", watchScroll);
  }, []);

  return (
    <div
      className={`${styles.container} ${isVisible ? styles.visible : styles.hidden
        }`}
    >
      <a
        className={styles.ctaFloat}
        href={`https://inscricao.kenzie.com.br/${params}`}
      >
        Entrar na Lista de Espera
      </a>
    </div>
  );
}
